import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "wedding_cookie_consent_v1";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        // Tiny delay so the page can settle first
        const t = setTimeout(() => setShow(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      setShow(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        accepted: true,
        at: new Date().toISOString(),
      }));
    } catch {
      /* localStorage might be blocked */
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 md:p-6 pointer-events-none"
    >
      <div className="pointer-events-auto max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl border border-sage-200 overflow-hidden">
        <div className="p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
          <div className="hidden md:flex shrink-0 w-12 h-12 rounded-full bg-sage-100 text-sage-600 items-center justify-center">
            <Cookie size={22} />
          </div>
          <div className="flex-1 text-sm text-sage-700 leading-relaxed">
            <p className="font-medium text-sage-800 mb-1">
              Ein kleiner Hinweis 🍪
            </p>
            <p>
              Diese Website nutzt nur <strong>technisch notwendigen Speicher</strong> für
              Funktionen wie den Admin-Login. Es werden{" "}
              <strong>keine Tracking- oder Werbe-Cookies</strong> gesetzt.
              Mehr Infos in der{" "}
              <Link to="/datenschutz" className="underline text-sage-600 hover:text-sage-800">
                Datenschutzerklärung
              </Link>
              .
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Link
              to="/datenschutz"
              data-testid="cookie-details-link"
              className="hidden sm:inline-block text-xs uppercase tracking-wide text-sage-600 hover:text-sage-800 px-3 py-2"
            >
              Details
            </Link>
            <button
              data-testid="cookie-accept-btn"
              onClick={accept}
              className="rounded-full bg-sage-500 hover:bg-sage-600 text-white px-6 py-2.5 text-xs uppercase tracking-[0.2em]"
            >
              Verstanden
            </button>
            <button
              data-testid="cookie-close-btn"
              onClick={accept}
              className="md:hidden p-2 text-sage-400 hover:text-sage-700"
              aria-label="Schließen"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
